export default __webpack_public_path__ + "static/media/Flag_of_Dominican_Republic.b171ab45.svg";